export default function isTouchEvent(event) {
  return event.type === 'touchend';
}